import { Box, BoxProps } from "@chakra-ui/react";
import { DATA_ATTR_JUMPMARK_SECTION, EnumJumpMarkSection } from "./consts";

interface IProps extends Omit<BoxProps, "name"> {
    section: EnumJumpMarkSection;
}

// the section where the specific jump mark should be active when visible
export const JumpMarkSection = ({ section, ...boxProps }: IProps) => <Box {...{ [DATA_ATTR_JUMPMARK_SECTION]: section }} {...boxProps} />;
